import { addMonths, differenceInDays, differenceInMonths } from "date-fns";

export function converterDataHora(data: Date | null): string {
    if (data == null) {
        return "";
    }
    data = new Date(data);
    return data.getDate().toString().padStart(2, "0") + "/" + (data.getMonth() + 1).toString().padStart(2, "0") + "/" + data.getFullYear().toString() + " " + data.getHours().toString().padStart(2, "0") + ":" + data.getMinutes().toString().padStart(2, "0");
}

export function converterHorario(horario: number): string {
    const hora = Math.floor(horario / 60);
    const minutos = horario % 60;
    return hora.toString().padStart(2, "0") + ":" + minutos.toString().padStart(2, "0");
}


export function converterData(data: Date | null | undefined): string {
    if (data == null || data == undefined) {
        return "";
    }
    data = new Date(data);
    return data.getDate().toString().padStart(2, "0") + "/" + (data.getMonth() + 1).toString().padStart(2, "0") + "/" + data.getFullYear().toString();
}

export function converterDataDiaMes(data: Date | null): string {
    if (data == null) {
        return "";
    }
    data = new Date(data);
    return data.getDate().toString().padStart(2, "0") + "/" + (data.getMonth() + 1).toString().padStart(2, "0");
}

export function diasParaVencer(validade: Date) {
    const hoje = new Date();

    const diffMonths = differenceInMonths(validade, hoje);
    const depoisMeses = addMonths(hoje, diffMonths);

    const diffDays = differenceInDays(validade, depoisMeses);

    const mesesStr = diffMonths > 0 ? (diffMonths === 1 ? `${diffMonths} mês` : `${diffMonths} meses`) : "";
    const diasStr = diffDays > 0 ? (diffDays === 1 ? `${diffDays} dia` : `${diffDays} dias`) : "";

    return `${mesesStr}${mesesStr && diasStr ? " e " : ""}${diasStr}`;
}

export function removerAcento(text: string): string {
    text = text.toLowerCase();
    text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
    text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
    return text;
}

export function numberToCnpj(value: number): string {
    if (value == null) {
        return "";
    }
    return value.toString().padStart(14, "0").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function formatarTelefone(text: string): string {
    if (text.length != 10 && text.length != 11) {
        return text;
    }
    let telefone = "(";
    telefone += text.substring(0, 2);
    telefone += ") "
    telefone += text.length == 11 ? text.substring(2, 7) : text.substring(2, 6)
    telefone += "-"
    telefone += text.length == 11 ? text.substring(7, 11) : text.substring(6, 10);
    return telefone;
}

export function formatarCnpj(text: string): string {
    return text.substring(0, 2) + "." + text.substring(2, 5) + "." + text.substring(5, 8) + "/" + text.substring(8, 12) + "-" + text.substring(12, 14);
}

export function formatarCep(text: string): string {
    return text.substring(0, 5) + "-" + text.substring(5, 9)
}